import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";

function FilterSelect({ testid, placeholder, value, onChange, options }) {
  return (
    <Select value={value || "__all"} onValueChange={(v) => onChange(v === "__all" ? "" : v)}>
      <SelectTrigger data-testid={testid} className="rounded-xl"><SelectValue placeholder={placeholder} /></SelectTrigger>
      <SelectContent>
        <SelectItem value="__all">{placeholder} : tous</SelectItem>
        {options.map((o) => <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}

export function DashboardFilters({ filters, setFilters, meta, sources }) {
  return (
    <div className="bg-white rounded-2xl border border-[#e2e8f0] p-4 mb-6">
      <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-3">
        <div className="relative">
          <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#9aa6c0]" />
          <Input data-testid="filter-search" placeholder="Rechercher…" value={filters.search}
            onChange={(e) => setFilters({ ...filters, search: e.target.value })}
            className="pl-9 rounded-xl" />
        </div>
        <FilterSelect testid="filter-profile" placeholder="Profil" value={filters.profile}
          onChange={(v) => setFilters({ ...filters, profile: v })}
          options={Object.entries(meta.profiles).map(([k, v]) => ({ value: k, label: v }))} />
        <FilterSelect testid="filter-status" placeholder="Statut" value={filters.status}
          onChange={(v) => setFilters({ ...filters, status: v })}
          options={meta.statuses.map((s) => ({ value: s, label: s }))} />
        <FilterSelect testid="filter-category" placeholder="Catégorie" value={filters.category}
          onChange={(v) => setFilters({ ...filters, category: v })}
          options={["Lead prioritaire", "Lead chaud", "Lead tiède", "Lead froid"].map((s) => ({ value: s, label: s }))} />
        <FilterSelect testid="filter-source" placeholder="Source" value={filters.source}
          onChange={(v) => setFilters({ ...filters, source: v })}
          options={sources.map((s) => ({ value: s, label: s }))} />
      </div>
    </div>
  );
}
